<template>
    <ResourcePage v-if="collection" :theme="theme" class="collection-page">
        <template #header>
            <ResourcePageHero :document="collection" />
        </template>
        <template #main>
            <SliceZone :components="components" :slices="collection?.data?.slices ?? []" />
        </template>
    </ResourcePage>
</template>

<script lang="ts" setup>
    import {ref, inject, computed} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import type {CollectionDocument} from '@prismicio-types';
    import {useRoute} from '@typed-router';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import {PRISMIC_DOCUMENT} from '~/app/keys';
    import ResourcePage from '~/components/ResourcePage.vue';
    import ResourcePageHero from '~/components/ResourcePageHero.vue';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {useResolvePrismicDocument} from '~/composables/content/useResolvePrismicDocument';
    import {useDocumentMetadata} from '~/composables/useDocumentMetadata';
    import {components} from '~/slices/components';

    const {
        params: {uid},
    } = useRoute('resources-collection-uid');
    const prismicDocument = inject(PRISMIC_DOCUMENT, ref());
    const {data, error} = await useAsyncData('collection', () => usePrismicDocument<CollectionDocument>('collection', uid as string));
    const collection = useResolvePrismicDocument(data, error);
    prismicDocument.value = collection.value;

    const theme = computed(() => {
        if (collection.value?.data.theme) {
            return collection.value?.data.theme;
        }
        if (collection.value?.data.useAlternativeHeroShapes) {
            return 'corporate';
        }
        return 'default';
    });

    if (collection.value) {
        useDocumentMetadata(collection.value);
    }

    useWebsitePageView('resources-center', 'collections');
</script>

<style lang="scss">
    .collection-page .resource-page__main {
        max-width: 100%;
    }
</style>
